<template>
    <admin-layout>

        <app-content-pane class="ml-3">
            <template #title>
                <div class="px-4 pt-3">
                    <h1>Create Learning Path</h1>
                    <nav>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><inertia-link :href="route('project.dashboard', {...global_url_params})">Change Projects</inertia-link></li>
                            <li class="breadcrumb-item"><inertia-link :href="route('project.learning-path.index', {...global_url_params})">Learning Paths</inertia-link></li>
                            <li class="breadcrumb-item active">Create Learning Path</li>
                        </ol>
                    </nav>
                </div>
                <hr class="mb-0">
            </template>


            <form class="px-4 py-3" autocomplete="off" @submit.prevent.stop="create()">

                <div class="row">
                    <div class="col-lg-7">
                        <div class="form-group">
                            <label for="path-name">Name</label>
                            <input id="path-name"
                                   type="text"
                                   v-model="values.name"
                                   :disabled="is_busy"
                                   class="form-control form-control-lg"
                                   :class="{'is-invalid': errors.name}"
                                   placeholder="Learning Path Name">
                            <div v-if="errors.name" class="invalid-feedback">
                                {{ errors.name.join(', ') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="d-block">Stages</label>
                            <div class="form-check form-check-inline" v-for="stage in available_stages" :key="stage">
                                <input class="form-check-input" type="checkbox" v-model="values.stages" :id="`stage-${stage}`" :value="stage">
                                <label class="form-check-label" :for="`stage-${stage}`">{{ utils.ucwords( stage ) }}</label>
                            </div>

                            <div v-if="errors.stages" class="invalid-feedback">
                                {{ errors.stages.join(', ') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="path-description">Description</label>
                            <textarea id="path-description"
                                      type="text"
                                      v-model="values.description"
                                      :disabled="is_busy"
                                      class="form-control"
                                      rows="5"
                                      :class="{'is-invalid': errors.description}"
                                      placeholder="A description that explains the learning path."></textarea>
                            <div v-if="errors.description" class="invalid-feedback">
                                {{ errors.description.join(', ') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="path-image">Preview Image</label>
                            <file-uploader id="path-image" v-model="values.image" />
                            <div v-if="errors.image" class="invalid-feedback">
                                {{ errors.image.join(', ') }}
                            </div>
                        </div>

                        <div v-if="is_admin" class="form-group">
                            <label>Editable By</label>
                            <select class="form-control" v-model="values.editable_by">
                                <option value="admin">Admin</option>
                                <option value="teacher">Teacher</option>
                            </select>
                        </div>

                        <state-button type="submit"
                                      :disabled="is_busy"
                                      :state="is_busy ? 'busy' : ''"
                                      class="btn btn-primary mr-3">Create</state-button>

                        <span class="text-danger">{{ error_message }}</span>

                    </div>
                </div>

            </form>

        </app-content-pane>

    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import LearningPathToolbox from "@/Components/Toolbox/LearningPathToolbox";
import ProjectCard from "@/Components/Project/ProjectCard";
import FidsSection from "@/Components/LearningPath/FidsSection";
import FileUploader from "@/Components/Common/FileUploader";
import {findModel} from "@/DATA/functions";
import learning_paths from "@/DATA/learning_paths";
import API from "@/API";
import utils from "@/mixins/utils";
import StateButton from "@/Components/Common/StateButton";

export default {
    name: "Edit",
    components: {StateButton, AdminLayout, AppContentPane, FileUploader, LearningPathToolbox, ProjectCard, FidsSection},
    mixins: [utils],

    props: {
        path: {
            type: [Object],
            default: () => null,
        }
    },

    data(){
        return {
            is_busy: false,
            values: {
                name: '',
                stages: ['intro', 'feel', 'imagine', 'do', 'share'],
                description: '',
                preview: null,
                editable_by: 'admin',
                tenant_id: null,
            },
            available_stages: ['intro', 'feel', 'imagine', 'do', 'share'],
            errors: {},
            error_message: '',
        };
    },


    methods: {
        async create(){

            this.is_busy        = true;
            this.errors         = {};
            this.error_message  = '';

            try{
                const path = await API.learning_paths.create(this.values);
                this.$inertia.visit( this.route('project.learning-path.edit', {path: path.id, ...this.global_url_params}) );
            } catch (e){
                if( typeof e.response?.data?.errors !== 'undefined' ){
                    this.errors = e.response.data.errors;
                    this.error_message = e.response.data.message;
                }else{
                    console.log({e});
                }
            }

            this.is_busy = false;

        }
    },

    mounted() {
        if( this.path ){
            this.lp = findModel( learning_paths, this.path );
        }

        this.values.tenant_id = this.active_tenant?.id;
        this.setTitle( `Create Learning Path` );
    }

}
</script>

<style lang="scss" scoped>
.actions{
    display: flex;
}
</style>
